import { callApi } from 'utils/api'

import _crud from './_crud'

const load = (options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/request`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options.params,
		})
		return res.body
	}
}

const add = (item, options = {}) => {
	const { showMessage = true } = options

	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi(`/request`, {
			method: 'POST',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: showMessage
				? `Se agregó el requerimiento correctamente.`
				: undefined,
		})

		let stored_item = res.body
		return stored_item
	}
}
const remove = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/request/${item.id}`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se eliminó el requerimiento correctamente.`,
		})
	}
}

const update = (item, shouldShowSuccessMessage = true) => {
	return async (dispatch, getState) => {
		const state = getState()
		let res = await callApi(`/request/${item.id}`, {
			method: 'PATCH',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage:
				shouldShowSuccessMessage &&
				`Se actualizó el requerimiento correctamente.`,
		})

		let stored_item = res.body
	}
}

const get = (id, options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/request/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options.params,
		})

		return res.body
	}
}

const bulkSync = ({ deleteItems, updateItems, createItems }, options = {}) => {
    return async (dispatch, getState) => {
      const state = getState();

      let res = await callApi(`/request/bulkSync`, {
        method: 'POST',
        body: JSON.stringify({
          deleteItems,
          updateItems,
          createItems
        }),
        headers: {
          Authorization: state.app.user.token
        },
        successMessage: `Se sincronizaron los requerimientos correctamente.`
      })

      let stored_item = res.body
      return stored_item
    }
  }

export default { load, add, remove, update, get, bulkSync }
